import React from 'react';
import { string } from 'prop-types';
// import { useHistory } from 'react-router-dom';
import { Row } from 'simple-flexbox';
import { createUseStyles, useTheme } from 'react-jss';
// import { IconBell, IconSearch } from 'assets/icons';
import Avatar from 'components/Avatar';
import DropdownComponent from 'components/dropdown';
import { useDispatch, useSelector } from 'react-redux';
import { logout, selectUser } from 'features/userSlice';

const useStyles = createUseStyles((theme) => ({
    avatar: {
        height: 35,
        width: 35,
        minWidth: 35,
        borderRadius: 50,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: 14,
        border: `1px solid #085d40`,
        backgroundColor: '#f0fdf4',
        color: '#085d40',
        '@media (max-width: 768px)': {
            marginLeft: 14
        }
    },
    container: {
        height: 60,
        backgroundColor: '#ffffff',
        borderRadius: '10px',
        // border: '1px solid #e2e8f0',
        padding: '0 24px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
        // marginBottom: '20px'
    },
    name: {
        ...theme.typography.itemTitle,
        textAlign: 'right',
        color: 'black',
        fontWeight: '600',
        '@media (max-width: 768px)': {
            display: 'none'
        }
    },
    separator: {
        borderLeft: `1px solid #e2e8f0`,
        marginLeft: 32,
        marginRight: 32,
        height: 32,
        width: 2,
        '@media (max-width: 768px)': {
            marginLeft: 14,
            marginRight: 0
        }
    },
    title: {
        ...theme.typography.title,
        color: 'black',
        fontSize: '20px',
        fontWeight: 'bold',
        '@media (max-width: 1080px)': {
            marginLeft: 50
        },
        '@media (max-width: 468px)': {
            fontSize: 20
        }
    },
    iconStyles: {
        cursor: 'pointer',
        marginLeft: 25,
        '@media (max-width: 768px)': {
            marginLeft: 12
        }
    }
}));

function HeaderComponent() {
    // const { push } = useHistory();
    const theme = useTheme();
    const classes = useStyles({ theme });

    const dispatch = useDispatch();
    const user = useSelector(selectUser);
    const handleLogout = () => {
        // Clear localStorage
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.clear(); // Clear all localStorage as fallback
        
        // Clear Redux state
        dispatch(logout());
        
        // Redirect to login (optional, but ensures clean logout)
        window.location.href = '/login';
    };

    return (
        <Row className={classes.container} vertical='center' horizontal='space-between'>
            {/* <span className={classes.title}>{title}</span> */}
            <span className={classes.title} style={{ color: '#085d40', fontWeight: '800' }}>
                AGRI-GATE LAYAWAY DASHBOARD
            </span>
            <Row vertical='center'>
                {/* <div className={classes.iconStyles}>
                    <IconSearch />
                </div> */}
                {/* <div className={classes.iconStyles}>
                    <DropdownComponent
                        label={<IconBell />}
                        options={[
                            {
                                label: 'Notification #1',
                                onClick: () => console.log('Notification #1')
                            },
                            {
                                label: 'Notification #2',
                                onClick: () => console.log('Notification #2')
                            },
                            {
                                label: 'Notification #3',
                                onClick: () => console.log('Notification #3')
                            },
                            {
                                label: 'Notification #4',
                                onClick: () => console.log('Notification #4')
                            }
                        ]}
                        position={{
                            top: 42,
                            right: -14
                        }}
                    />
                </div> */}
                <div className={classes.separator}></div>
                <DropdownComponent
                    label={
                        <>
                            <span className={classes.name}>{user.email}</span>
                            <Avatar name='Admin' className={classes.avatar} />
                        </>
                    }
                    options={[
                        {
                            label: 'Logout',
                            onClick: () => handleLogout()
                        }
                    ]}
                    position={{
                        top: 52,
                        right: -6
                    }}
                />
            </Row>
        </Row>
    );
}

HeaderComponent.propTypes = {
    title: string
};

export default HeaderComponent;
